import React from 'react'

import Footer from './Footer'
import avatar from '../assets/images/siwei.png'
import resume from '../assets/files/resume.pdf'

class Header extends React.Component {
  render() {
    return (
      <header id="header">
        <div className="inner headerContent">
          <a href="#" className="image avatar">
            <img src={avatar} alt="" />
          </a>
          <h1>
            <strong>Siwei Fu (傅四维)</strong>
          </h1>
          <h4>
            <p>
              A research scientist at <br />
              <a href="https://en.zhejianglab.com/">Zhejiang Lab</a>
            </p>
            <br />
          </h4>
          <div className="navItems">
            <ul className="items">
              <li>
                <a href="#one" className="icon fa fa-user">
                  <span className="label">Bio</span>
                </a>
              </li>
              <li>
                <a href="#two" className="icon fa fa-edit">
                  <span className="label">Publications</span>
                </a>
              </li>
              {/* <li>
                <a href="#three" className="icon fa fa-picture-o">
                  <span className="label">Projects</span>
                </a>
              </li> */}
              <li>
                <a href="#four" className="icon fa fa-envelope-o">
                  <span className="label">Contact</span>
                </a>
              </li>
              <li>
                <a href={resume} className="icon fa fa-download">
                  <span className="label">Resume</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <Footer />
      </header>
    )
  }
}

export default Header



// WEBPACK FOOTER //
// ./src/components/Header.js